export const Background = ({ children, whiteBackground, allowScroll }) => (
  <div
    className={`nora-app-shell ${whiteBackground ? 'nora-app-shell--white' : ''} ${allowScroll ? 'nora-app-shell--scroll' : ''}`}
  >
    {children}
  </div>
)
